import { CORE_PERMISSIONS } from "./corePermissionKeys.js";
export const permissionDependencies = {
    // Manager permission dependencies
    [CORE_PERMISSIONS.RESPONDENT_WRITE]: [
        CORE_PERMISSIONS.RESPONDENT_READ,
        CORE_PERMISSIONS.RESPONDENT_LIST
    ],
    [CORE_PERMISSIONS.RESPONDENT_READ]: [
        CORE_PERMISSIONS.RESPONDENT_LIST
    ],
    [CORE_PERMISSIONS.RESPONDENT_DOCUMENT_WRITE]: [
        CORE_PERMISSIONS.RESPONDENT_DOCUMENT_READ
    ],
    [CORE_PERMISSIONS.RESPONDENT_NOTE_WRITE]: [
        CORE_PERMISSIONS.RESPONDENT_NOTE_READ
    ],
    [CORE_PERMISSIONS.BOOKING_READ_INCLUDE_ALL_RESPONDENT_BOOKINGS]: [
        CORE_PERMISSIONS.BOOKING_READ
    ],
    [CORE_PERMISSIONS.BOOKING_READ_INCLUDE_AFFILIATE_BOOKINGS]: [
        CORE_PERMISSIONS.BOOKING_READ
    ],
    [CORE_PERMISSIONS.BOOKING_WRITE]: [
        CORE_PERMISSIONS.BOOKING_READ
    ],
    [CORE_PERMISSIONS.BOOKING_DOCUMENT_WRITE]: [
        CORE_PERMISSIONS.BOOKING_DOCUMENT_READ
    ],
    [CORE_PERMISSIONS.SURVEY_WRITE]: [
        CORE_PERMISSIONS.SURVEY_READ
    ],
    // External User permission dependencies
    [CORE_PERMISSIONS.SURVEY_COMPLETED_SEND]: [
        CORE_PERMISSIONS.SURVEY_READ
    ],
    // Admin permission dependencies
    [CORE_PERMISSIONS.MANAGE_BOOKING_COMPANIES]: [
        CORE_PERMISSIONS.MANAGE_BOOKINGS
    ],
    [CORE_PERMISSIONS.MANAGE_RESPONDENT_COMPANIES]: [
        CORE_PERMISSIONS.MANAGE_RESPONDENTS
    ],
    [CORE_PERMISSIONS.MANAGE_BOOKING_PAGE_COMPANIES]: [
        CORE_PERMISSIONS.MANAGE_SERVICES_LOCATIONS_BOOKING_PAGES
    ],
    // Sales and Invoicing dependencies
    [CORE_PERMISSIONS.CONFIGURE_SALES_AND_INVOICING]: [
        CORE_PERMISSIONS.MANAGE_SALES_INVOICE_CONFIG,
        CORE_PERMISSIONS.MANAGE_TAX_RATES,
        CORE_PERMISSIONS.MANAGE_ITEMS,
        CORE_PERMISSIONS.MANAGE_SERVICE_SURVEY_ITEMS_CONFIG,
        CORE_PERMISSIONS.MANAGE_BOOKING_PAGE_PAYMENT_CONFIG
    ],
    [CORE_PERMISSIONS.INVOICES_AND_PAYMENTS]: [
        CORE_PERMISSIONS.VIEW_ALL_INVOICES,
        CORE_PERMISSIONS.CREATE_INVOICES,
        CORE_PERMISSIONS.EDIT_INVOICES,
        CORE_PERMISSIONS.CHANGE_INVOICE_PAYMENT_STATUS,
        CORE_PERMISSIONS.EXPORT_SEND_INVOICES,
        CORE_PERMISSIONS.MANAGE_ADD_ON_CHARGES,
        CORE_PERMISSIONS.VIEW_PAYMENT_TRANSACTION
    ],
    [CORE_PERMISSIONS.CREATE_INVOICES]: [
        CORE_PERMISSIONS.VIEW_ALL_INVOICES
    ],
    [CORE_PERMISSIONS.EDIT_INVOICES]: [
        CORE_PERMISSIONS.VIEW_ALL_INVOICES,
        CORE_PERMISSIONS.CREATE_INVOICES
    ],
    [CORE_PERMISSIONS.CHANGE_INVOICE_PAYMENT_STATUS]: [
        CORE_PERMISSIONS.VIEW_ALL_INVOICES,
        CORE_PERMISSIONS.VIEW_PAYMENT_TRANSACTION
    ],
    [CORE_PERMISSIONS.EXPORT_SEND_INVOICES]: [
        CORE_PERMISSIONS.VIEW_ALL_INVOICES
    ],
    [CORE_PERMISSIONS.MANAGE_ADD_ON_CHARGES]: [
        CORE_PERMISSIONS.VIEW_ALL_INVOICES
    ],
    [CORE_PERMISSIONS.VIEW_PAYMENT_TRANSACTION]: [
        CORE_PERMISSIONS.VIEW_ALL_INVOICES
    ],
};
//# sourceMappingURL=permissionDependencies.js.map